import React, { ReactNode } from 'react';
import { styled } from '@linaria/react';
import { Card } from '@daedalus/atlas/Card';
const _exp = /*#__PURE__*/() => Card;
export const ThickBorderCard = /*#__PURE__*/styled(_exp())({
  name: "ThickBorderCard",
  class: "tut5l4u",
  propsAsIs: true
});
const _exp2 = /*#__PURE__*/() => ({
  bgColor
}) => bgColor;
const _exp3 = /*#__PURE__*/() => ({
  contentColor
}) => contentColor;
const HeaderLayoutWrapper = /*#__PURE__*/styled('div')({
  name: "HeaderLayoutWrapper",
  class: "h1988kde",
  propsAsIs: false,
  vars: {
    "h1988kde-0": [_exp2()],
    "h1988kde-1": [_exp3()]
  }
});
export const CardHeaderLayout = ({
  iconSlot,
  titleSlot,
  bgColor,
  contentColor
}: {
  iconSlot: ReactNode;
  titleSlot: ReactNode;
  bgColor: string;
  contentColor: string;
}) => {
  return <HeaderLayoutWrapper bgColor={bgColor} contentColor={contentColor}>
      {iconSlot}
      {titleSlot}
    </HeaderLayoutWrapper>;
};

require("./RoomVariant.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./RoomVariant.tsx");